import React from "react";
import Lottie from "react-lottie";
import loader from "../../../assets/lotties/loader.json";
import "./style.css";

// Loader component - uses clean CSS spinner for overlay, Lottie for inline
export default function Loader({ 
  value, 
  variant = "fullscreen", 
  size = "medium",
  text = "Loading...",
  className = ""
}) {
  if (!value) return null;

  const sizeConfig = {
    small: { spinner: 20, text: "12px" },
    medium: { spinner: 28, text: "13px" },
    large: { spinner: 32, text: "13px" },
    xlarge: { spinner: 40, text: "14px" }
  };
  const currentSize = sizeConfig[size] || sizeConfig.medium;

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loader,
    rendererSettings: { preserveAspectRatio: "xMidYMid slice" }
  };

  // Overlay: clean CSS spinner (no card, no Lottie)
  if (variant === "fullscreen" || variant === "overlay") {
    return (
      <div className={`loader-overlay ${className}`}>
        <div className="loader-spinner-wrap" style={{ width: currentSize.spinner, height: currentSize.spinner }}>
          <div className="loader-spinner" />
        </div>
        {text && <span className="loader-text" style={{ fontSize: currentSize.text }}>{text}</span>}
      </div>
    );
  }

  // Inline: Lottie
  const content = (
    <div className="loader-inline">
      <Lottie options={defaultOptions} height={currentSize.spinner} width={currentSize.spinner} />
      {text && <span className="loader-text" style={{ fontSize: currentSize.text }}>{text}</span>}
    </div>
  );
  return <div className={className} style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}>{content}</div>;
}
